<template>
    <div class="the-navbar__user-meta flex items-center">
        <ADropdown :trigger="['click']" style="z-index: 250000">
            <div class="flex items-center">
                <div class="ml-2 text-primary">
                  <p class="font-semibold mb-0">
                      {{ username.name  }}
                  </p>
                  <p class="font-semibold mb-0">
                    {{username.user_type_type}}
                  </p>
                </div>
                <div class="con-img ml-3">
                    <feather-icon icon="UserIcon" class="cursor-pointer" svg-classes="text-primary" size="42px"/>
                </div>
            </div>
            <ACard slot="overlay">
                <ul style="min-width: 9rem;z-index: 25000">
                    <li
                            @click="logout"
                            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
                        <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
                        <span class="ml-2">خروج از حساب کاربری</span>
                    </li>
                </ul>
            </ACard>
        </ADropdown>
    </div>
</template>

<script>

    import 'firebase/auth';

    export default {
        data() {
            return {};
        },
        computed: {
            activeUserInfo() {
                const j = localStorage.getItem('user');
                if (!j || j == 'undefined') {
                    return {};
                }
                const s = JSON.parse(j || '{}');
                return s;
            },
            username(){
                return JSON.parse(localStorage.getItem('userInfo'))
               // console.log(data,'dayaaaaaaa');
            }
        },
        methods: {
            logout() {
                if (sessionStorage.getItem('accessToken')) {
                    sessionStorage.removeItem('user');
                    sessionStorage.removeItem('accessToken');
                }
                this.$router.push('/auth/login').catch(() => {
                });
            }
        }
    };
</script>
